import PropTypes from 'prop-types';
import React from 'react';
import { CardContentSkeleton } from '../skeleton/card-content-skeleton';
import { MeasurementTypeCard } from '../measurement-type-card';

const noop = () => {};

export const VisitConversionLiftLoading = ({ title }) => (
  <MeasurementTypeCard
    description={null}
    helpId="pop_BA_Experiments_VisitsConversions"
    isAllowed={false}
    isEnabled={false}
    onToggle={noop}
    title={title}
  >
    <CardContentSkeleton />
  </MeasurementTypeCard>
);

VisitConversionLiftLoading.propTypes = {
  title: PropTypes.string.isRequired,
};
